import React, { useState } from 'react';

interface EmojiPickerProps {
  selectedEmoji: string;
  onEmojiSelect: (emoji: string) => void;
  className?: string;
}

const EMOJI_CATEGORIES = {
  'Movie & Entertainment': ['🎬', '🎭', '🎪', '🎨', '🎵', '🎤', '🎧', '📺', '📽️', '🎞️'],
  'Faces & Emotions': ['😀', '😃', '😄', '😁', '😆', '😅', '😂', '🤣', '😊', '😇', '🙂', '🙃', '😉', '😌', '😍', '🥰', '😘', '😗', '😙', '😚'],
  'Objects & Symbols': ['⭐', '🌟', '✨', '💫', '🔥', '💎', '👑', '🏆', '🎯', '🎪', '🎨', '🎭', '🎪', '🎨', '🎭', '🎪', '🎨', '🎭'],
  'Animals & Nature': ['🦁', '🐯', '🐻', '🐼', '🐨', '🐸', '🐵', '🦄', '🐺', '🦊', '🐱', '🐶', '🐰', '🐹', '🐭', '🐷', '🐮', '🐗'],
  'Food & Drinks': ['🍿', '🍕', '🍔', '🌭', '🥪', '🌮', '🌯', '🥙', '🧆', '🥚', '🍳', '🥘', '🍲', '🥗', '🍜', '🍝', '🍛', '🍣'],
  'Activities': ['⚽', '🏀', '🏈', '⚾', '🥎', '🎾', '🏐', '🏉', '🥏', '🎱', '🪀', '🏓', '🏸', '🏒', '🏑', '🥍', '🏏', '🪃']
};

const EmojiPicker: React.FC<EmojiPickerProps> = ({
  selectedEmoji,
  onEmojiSelect,
  className = ''
}) => {
  const [activeCategory, setActiveCategory] = useState<string>('Movie & Entertainment');

  return (
    <div className={`bg-white border border-gray-200 rounded-lg shadow-lg p-4 ${className}`}>
      {/* Category Tabs */}
      <div className="flex flex-wrap gap-1 mb-4 border-b border-gray-200 pb-2">
        {Object.keys(EMOJI_CATEGORIES).map((category) => (
          <button
            key={category}
            onClick={() => setActiveCategory(category)}
            className={`px-2 py-1 text-xs rounded transition-colors ${
              activeCategory === category
                ? 'bg-primary text-white'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }`}
          >
            {category.split(' ')[0]}
          </button>
        ))}
      </div>

      {/* Emoji Grid */}
      <div className="grid grid-cols-8 gap-2 max-h-48 overflow-y-auto">
        {EMOJI_CATEGORIES[activeCategory as keyof typeof EMOJI_CATEGORIES].map((emoji) => (
          <button
            key={emoji}
            onClick={() => onEmojiSelect(emoji)}
            className={`w-8 h-8 text-lg hover:bg-gray-100 rounded transition-colors flex items-center justify-center ${
              selectedEmoji === emoji ? 'bg-primary/20 ring-2 ring-primary' : ''
            }`}
            title={emoji}
          >
            {emoji}
          </button>
        ))}
      </div>

      {/* Selected Emoji Display */}
      {selectedEmoji && (
        <div className="mt-4 pt-4 border-t border-gray-200">
          <div className="flex items-center gap-2">
            <span className="text-sm text-gray-600">Selected:</span>
            <span className="text-2xl">{selectedEmoji}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default EmojiPicker;